/* Step 11d · add-on (lane D5, 01-Nov-2026) — adjustable column widths: EN + AR texts of the shared primitive
   (components/ui/resizable-table.jsx): the "Reset column widths" control of every resizable table and the drag handle. */
export default {
  en: {
    colWidths: {
      reset: "Reset column widths",
      resetHint: "Back to the default widths of this table",
      handle: "Resize column — drag to adjust width",
      handleHint: "Drag to resize · double-click to fit",
    },
  },
  ar: {
    colWidths: {
      reset: "إعادة عرض الأعمدة",
      resetHint: "العودة إلى العرض الافتراضي لأعمدة هذا الجدول",
      handle: "تغيير عرض العمود — اسحب لضبط العرض",
      handleHint: "اسحب لتغيير العرض · انقر نقرًا مزدوجًا للملاءمة",
    },
  },
};
